<template>
  <div>
    <div :id="id" class="emoji-field" tabindex="-1">
      <slot></slot>
    </div>
    <b-popover
      @shown="$emit('shown')"
      @hidden="onHidden"
      ref="popover"
      :target="id"
      triggers="click blur"
      custom-class="emoji-picker-popover"
    >
      <emojis-list
        class="emoji-list-comp"
        :emojis="emojis"
        @select="onSelect"
        v-if="emojis.length > 0"
      />
    </b-popover>
  </div>
</template>

<script>
import EmojisList from '@/components/reactions/EmojisList'
import fetchEmojiData from '@/components/reactions/fetchEmojiData'
import random from '@/utils/random'
import { BPopover } from 'bootstrap-vue'

const frequentlyUsedEmojis = [
  'THUMBS UP SIGN',
  'DIRECT HIT',
  'EYES',
  'HEAVY BLACK HEART',
  'HUNDRED POINTS SYMBOL',
  'PARTY POPPER',
  'FLEXED BICEPS',
  'CLAPPING HANDS SIGN',
  'PERSON RAISING BOTH HANDS IN CELEBRATION',
  'WHITE HEAVY CHECK MARK',
  'OK HAND SIGN',
  'FACE WITH TEARS OF JOY',
  'PERSON WITH FOLDED HANDS',
  'TROPHY',
  'ROCKET',
  'SHIP'
]

/**
 * This component enables user to pick an emoji
 * slots:
 * default: click on this slot open emoji picker in popover
 *
 * @emits
 * - shown: when emoji picker popover is shown
 * - hidden: when emoji picker popover is hidden
 * - select: when an emoji is selected. emoji's unicode codepoint is sent as payload
 */
export default {
  name: 'EmojiPicker',
  components: {
    BPopover,
    EmojisList
  },
  data() {
    return {
      id: 'emoji-picker-' + random(5),
      emojiData: []
    }
  },
  computed: {
    emojis() {
      return frequentlyUsedEmojis.map(emojiName =>
        this.emojiData.find(emoji => emoji.name === emojiName)
      )
    }
  },
  async mounted() {
    const emojiData = await fetchEmojiData()
    this.emojiData = emojiData.filter(x => x.category !== 'Skin Tones') // Removing skin tones category for now
  },
  methods: {
    onSelect(emoji) {
      this.$refs.popover.$emit('close')
      this.$emit('select', emoji.unified)
    },
    onHidden() {
      this.$emit('hidden')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/_input.scss';

.emoji-list-comp {
  padding: 12px;
}
</style>

<style lang="scss">
.emoji-picker-popover {
  border-radius: 16px;

  &.popover {
    max-width: 360px;
    min-width: 360px;
  }

  .popover-body {
    padding: 0;
  }
}
</style>
